/**
 * Дзеркало `api/src/modules/push/push-data.types.ts` і
 * `api/src/common/enums/push-type.enum.ts`. Тримати у синхроні з беком.
 *
 * Discriminated union по `type` дає компайл-таймову гарантію, що для конкретного
 * типу присутні всі потрібні поля для роутингу/UI.
 */

export enum PushType {
  CHAT_MESSAGE        = 'CHAT_MESSAGE',
  APPOINTMENT         = 'APPOINTMENT',
  APPOINTMENT_REVIEW  = 'APPOINTMENT_REVIEW',
  NEWS                = 'NEWS',
  CALENDAR_EVENT      = 'CALENDAR_EVENT',
  CONNECTION_REQUEST  = 'CONNECTION_REQUEST',
  CONNECTION_RESPONSE = 'CONNECTION_RESPONSE',
  PERMISSIONS_UPDATED = 'PERMISSIONS_UPDATED',
  PAYMENT_SUCCESS     = 'PAYMENT_SUCCESS',
  PAYMENT_FAILED      = 'PAYMENT_FAILED',
  ORDER_UPDATED       = 'ORDER_UPDATED',
  SURVEY_INVITE_ACCEPTED  = 'SURVEY_INVITE_ACCEPTED',
  SURVEY_INVITE_COMPLETED = 'SURVEY_INVITE_COMPLETED',
  SURVEY_ASSIGNED         = 'SURVEY_ASSIGNED',
  DEFAULT             = 'DEFAULT',
}

export type PushData =
  | { type: PushType.CHAT_MESSAGE; conversationId: string; senderId: string; senderAvatar?: string }
  | { type: PushType.APPOINTMENT; id: string }
  | { type: PushType.APPOINTMENT_REVIEW; id: string }
  | { type: PushType.NEWS; id: string; imageUrl?: string }
  | { type: PushType.CALENDAR_EVENT; eventId: string; eventTypeId: string; scheduledLdt: string; isGroup: string; eventIds: string }
  | { type: PushType.CONNECTION_REQUEST; clientId: string }
  | { type: PushType.CONNECTION_RESPONSE; expertId: string; accepted: string }
  | { type: PushType.PERMISSIONS_UPDATED; clientId: string }
  | { type: PushType.PAYMENT_SUCCESS; planName: string; timestamp: string }
  | { type: PushType.PAYMENT_FAILED; reason?: string; timestamp: string }
  | { type: PushType.ORDER_UPDATED }
  | { type: PushType.SURVEY_INVITE_ACCEPTED; clientId: string; templateId: string }
  | { type: PushType.SURVEY_INVITE_COMPLETED; clientId: string; templateId: string }
  | { type: PushType.SURVEY_ASSIGNED; templateId: string }
  | { type: PushType.DEFAULT };
